import { List, Modal, Spin } from "antd";
import { useEffect, useState } from "react";
import InstitutionCardRankCompare from "Benchmarking/Components/InstitutionCardRankCompare";
import ItemCompareInstitution from "Benchmarking/Components/ItemCompareInstitution";
import MultiLineChart from "Benchmarking/Components/MultiLineChart";
import { findMax } from "Benchmarking/Config/UtilFunction";
import "Benchmarking/Scss/CompareInstitution.scss";
import {
  getInstitutionCompare,
  getInstitutionDepartmentById,
  getInstitutionRank,
  getSearchInstitution,
} from "Benchmarking/Services/Institution";
import SearchAdvanceInstitutionModal from "Benchmarking/Components/SearchAdvanceInstitutionModal";

const CompareInstitution = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [openAdd, setOpenAdd] = useState(false);
  const [searchResultList, setSearchResultList] = useState([]);
  const [candidateIndex, setCandidateIndex] = useState(-1);
  const [candidateList, setCandidateList] = useState({
    0: null,
    1: null,
    2: null,
    3: null,
  });
  const [candidateIdList, setCandidateIdList] = useState([]);
  const [candidates, setCandidates] = useState([]);
  const [filters, setFilters] = useState({
    query: null,
    classifications: null,
    states: null,
  });
  const [maxData, setMaxData] = useState({});
  const handleOk = () => {
    setOpenAdd(false);
  };
  const handleCancel = () => {
    setOpenAdd(false);
  };

  useEffect(() => {
    if (
      filters.query !== null ||
      filters.classifications !== null ||
      filters.states !== null
    ) {
      setIsLoading(true);
      getInstitutionRank(filters, (res) => {
        setSearchResultList(res);
        setIsLoading(false);
      });
    }
  }, [filters]);
  useEffect(() => {
    if (candidateIdList.length > 0) {
      getInstitutionCompare(candidateIdList, (res) => {
        setCandidates(res);
        setMaxData(findMax(res));
        const data_add = res.find(
          (item) => item.id === candidateIdList[candidateIndex].id
        );
        getInstitutionDepartmentById(
          candidateIdList[candidateIdList.length - 1].id,
          (res) => {
            const departments = res.map((item) => {
              return {
                value: item,
                label: item,
              };
            });
            if (candidateIndex !== -1) {
              setCandidateList({
                ...candidateList,
                [candidateIndex]: {
                  data: data_add,
                  filters: filters,
                  departments: departments,
                },
              });
            }
          }
        );
      });
    }
  }, [candidateIdList]);
  return (
    <div className="compare-institution">
      <Modal
        title="Search for candidate"
        open={openAdd}
        onOk={handleOk}
        onCancel={handleCancel}
        width={1000}
        style={{
          top: 20,
        }}
      >
        <SearchAdvanceInstitutionModal
          filters={filters}
          setFilters={setFilters}
        />

        {isLoading ? (
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minHeight: "300px",
            }}
          >
            <Spin />
          </div>
        ) : (
          <div className={searchResultList.length > 3 ? "data-content" : ""}>
            <List
              grid={{
                gutter: 25,
                column: 4,
              }}
              dataSource={searchResultList}
              renderItem={(item, index) => {
                return (
                  <List.Item key={index}>
                    <InstitutionCardRankCompare
                      data={item}
                      candidateList={candidateList}
                      setCandidateList={setCandidateList}
                      candidates={candidates}
                      setCandidates={setCandidates}
                      setOpenAdd={setOpenAdd}
                      candidateIndex={candidateIndex}
                      isCompare={true}
                      filters={filters}
                      candidateIdList={candidateIdList}
                      setCandidateIdList={setCandidateIdList}
                    />
                  </List.Item>
                );
              }}
            />
          </div>
        )}
      </Modal>
      <p className="header">Select suitable candidates</p>
      <div className="compare-list">
        <ItemCompareInstitution
          candidateList={candidateList}
          setCandidateList={setCandidateList}
          candidateIdList={candidateIdList}
          setCandidateIdList={setCandidateIdList}
          setCandidateIndex={setCandidateIndex}
          candidates={candidates}
          setCandidates={setCandidates}
          setOpenAdd={setOpenAdd}
          maxData={maxData}
        />
      </div>
      <div className="citation-chart">
        {candidates.length > 0 && <MultiLineChart data={candidates} />}
      </div>
    </div>
  );
};

export default CompareInstitution;
